import React, { PureComponent } from 'react'
import DesignerBody from '../components/DesignerBody.js'
import CushionDesignerSteps from '../components/CushionDesignerSteps.js'
import { Redirect, Route, Switch } from 'react-router-dom'
import CushionFillingSelector from '../components/CushionFillingSelector.js'
import CushionFastenerSelector from '../components/CushionFastenerSelector.js'
import CushionStyleSelector from '../components/CushionStyleSelector.js'
import CushionFabricSelector from '../components/CushionFabricSelector/CushionFabricSelector.js'
import CushionDimensionsSelector from '../components/CushionDimensionsSelector.js'
import CushionTypeSelector from '../components/CushionTypeSelector.js'
import {
  DESIGNER_STEPS_CUSTOM_DEEP_SEATING,
  DESIGNER_STEPS_URLS_CUSTOM_DEEP_SEATING,
} from '../utils/config.js'
import CushionSetSelector from '../components/CushionSetSelector.js'

class DeepSeatingRouter extends PureComponent {
  constructor(props) {
    super(props)
  }

  render() {
    return (
      <DesignerBody urls={DESIGNER_STEPS_URLS_CUSTOM_DEEP_SEATING}>
        <CushionDesignerSteps
          steps={DESIGNER_STEPS_CUSTOM_DEEP_SEATING}
          urls={DESIGNER_STEPS_URLS_CUSTOM_DEEP_SEATING}
        />
        <Switch>
          <Route path={'/cd/:category/:type/:set/:dimensions/:fabric/:style/:fasteners/:filling'}>
            <CushionFillingSelector />
          </Route>
          <Route path={'/cd/:category/:type/:set/:dimensions/:fabric/:style/:fasteners'}>
            <CushionFastenerSelector />
          </Route>
          <Route path={'/cd/:category/:type/:set/:dimensions/:fabric/:style'}>
            <CushionStyleSelector />
          </Route>
          <Route path={'/cd/:category/:type/:set/:dimensions/:fabric'}>
            <CushionFabricSelector />
            <p className={'cushion-designer-footer-text'}></p>
          </Route>
          <Route path={'/cd/:category/:type/:set/:dimensions'}>
            <CushionDimensionsSelector />
          </Route>
          <Route path={'/cd/:category/:type/:set'}>
            <CushionSetSelector />
            <p className={'cushion-designer-footer-text'}>
              Select the furniture set for your custom deep seating design by clicking on one of the
              options above.
            </p>
          </Route>
          <Route path={'/cd/:category/:type'}>
            <div className={'cushion-designer-layout type-selector'}>
              <CushionTypeSelector />
              <p className={'cushion-designer-footer-text'}>
                Welcome to the Cushion Designer, a one-of-a-kind custom cushion builder engineered
                to put ease and enjoyment at the forefront of design. Follow the step-by-step
                prompts on screen to create your custom cushion.
              </p>
            </div>
          </Route>
          <Route path={'/cd/:category'}>
            <Redirect to={'/cd/category/type'} />
          </Route>
          <Route exact path={'/cd'}>
            <Redirect to={'/cd/category/type'} />
          </Route>
          <Route exact path={'/'}>
            <Redirect to={'/cd/category/type'} />
          </Route>
        </Switch>
      </DesignerBody>
    )
  }
}

export default DeepSeatingRouter
